import React, { useState } from "react";
import { TableRow, TableCell } from "@material-ui/core";
import { stableSort, getComparator } from "App/Component/ui/datatable/utils";
import {
  ModalDefaultError,
  ModalDeleteConfirm,
  TableAction,
  TableWrapper,
  TableCellDefault,
} from "App/Component/ui";

import { useDatatables, useFetch } from "App/hooks";
import {
  ModalForm,
  headCells,
  deletePendidikanById,
  RESET_STATE_PENDIDIKAN,
  urlGet,
} from "./helpers";
import { TYPE_INSTANCE2 } from "App/constants";
import {
  defaultToastError,
  defaultToastSuccess,
  fetchData,
} from "App/utils/helpers";

export default function Pendidikan() {
  const [showModal, setShowModal] = useState(false);
  const [showModalDefaultError, setShowModalDefaultError] = useState(false);
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);
  const [rows, setRows] = useFetch(TYPE_INSTANCE2, urlGet);

  const [formData, setFormData] = useState(RESET_STATE_PENDIDIKAN);

  function clickAdd() {
    setFormData(RESET_STATE_PENDIDIKAN);
    setShowModal(!showModal);
  }

  function clickUpdate(row) {
    setFormData({
      id: row?.id,
      name: row?.name,
    });

    setShowModal(true);
  }

  function clickDelete(row) {
    setFormData({
      ...formData,
      id: row?.id,
    });
    setShowModalDeleteConfirm(!showModalDeleteConfirm);
  }

  async function setNewData() {
    const res = await fetchData(TYPE_INSTANCE2, urlGet);
    setRows(res);
  }

  async function deleteList() {
    const res = await deletePendidikanById(formData.id);

    if (res.state) {
      defaultToastSuccess(res.message);
      setNewData();
    } else {
      defaultToastError(res.message);
    }

    setShowModalDeleteConfirm(false);
  }

  return (
    <>
      {showModal && (
        <ModalForm
          setNewData={setNewData}
          setShowModal={() => setShowModal(false)}
          defaultForm={formData}
        />
      )}

      {showModalDefaultError && (
        <ModalDefaultError
          setShowModalDefaultError={() => setShowModalDefaultError(true)}
        />
      )}

      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() => deleteList()}
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}

      <TablePendidikan
        rows={rows}
        clickDelete={clickDelete}
        clickUpdate={clickUpdate}
        clickAdd={clickAdd}
      />
    </>
  );
}

const TablePendidikan = ({ rows, clickDelete, clickUpdate, clickAdd }) => {
  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: rows,
    orderByDefault: "name",
    orderByRow: ["name"],
  });

  return (
    <TableWrapper
      title='Daftar Pendidikan'
      setQ={setQ}
      clickAddButton={() => clickAdd()}
      withExportButton={false}
      order={order}
      orderBy={orderBy}
      handleRequestSort={handleRequestSort}
      length={length}
      rows={rows}
      headCells={headCells}
      page={page}
      setPage={setPage}
      rowsPerPage={rowsPerPage}
      setRowsPerPage={setRowsPerPage}>
      {stableSort(data, getComparator(order, orderBy))
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        .map((row, index) => {
          return (
            <TableRow
              hover
              tabIndex={-1}
              key={index}
              style={{
                backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
              }}>
              <TableCell
                component='th'
                scope='row'
                padding='none'
                align='center'>
                {index + 1}
              </TableCell>

              <TableCell component='th' scope='row' padding='none'>
                <TableAction
                  clickDelete={() => clickDelete(row)}
                  clickUpdate={() => clickUpdate(row)}
                />
              </TableCell>

              <TableCell align='left'>{row?.name}</TableCell>
              <TableCellDefault row={row} />
            </TableRow>
          );
        })}
    </TableWrapper>
  );
};
